export const CONTRACT_TYPE_LABELS: Record<string, string> = {
  installation: "Instalación",
  public_tender: "Licitación pública",
  framework: "Marco",
  maintenance: "Mantenimiento",
  mixed: "Mixto",
  internal: "Interno",
  other: "Otro",
};

export function contractTypeLabel(contractType: string | null | undefined): string {
  if (!contractType) return "Tipo de contrato no especificado";
  return CONTRACT_TYPE_LABELS[contractType] ?? "Otro tipo de contrato";
}
